import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation } from 'react-query';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';

interface IVideoUploadAuthUrl {
  videoId: number;
}

interface IAuthUrlResponse {
  url: string;
}

const getVideoUploadAuthUrl = async (
  body: IVideoUploadAuthUrl
): Promise<IAuthUrlResponse> => {
  return (
    await EXPRESS_API.post<IAuthUrlResponse>(
      '/youtube/auth-url-video-upload',
      body
    )
  ).data;
};

export const useGetAuthUrlMutation = () => {
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(getVideoUploadAuthUrl, {
    onError: e => {
      showError(
        e,
        t('There was a problem getting the auth URL. Please try again.')
      );
    },
  });
};
